import { userSelectedConstants } from './local';

export const COOKIE_CONSENT_COOKIE = 'cookie_consent';

export const SUBMIT_COOKIE_CONSENT_PREFIX = 'submit_cookie_consent_';

export const COOKIE_CONSENT_DURATION = 365 * 24 * 60 * 60 * 1000; // 1 year in milliseconds

export enum CONSENT_NAME {
  AD_STORAGE = 'ad_storage',
  AD_USER_DATA = 'ad_user_data',
  AD_PERSONALIZATION = 'ad_personalization',
  ANALYTICS_STORAGE = 'analytics_storage',
  FUNCTIONALITY_STORAGE = 'functionality_storage',
  PERSONALIZATION_STORAGE = 'personalization_storage',
  SECURITY_STORAGE = 'security_storage',
}

// User selected cookies - Gtag consent mapping
// For use to check user's cookie consent for a single cookie
export const nonRequiredCookieConsentMapping = {
  [CONSENT_NAME.AD_STORAGE]: [],
  [CONSENT_NAME.AD_USER_DATA]: [],
  [CONSENT_NAME.AD_PERSONALIZATION]: [],
  [CONSENT_NAME.ANALYTICS_STORAGE]: [],
  [CONSENT_NAME.FUNCTIONALITY_STORAGE]: [
    userSelectedConstants.TERMINAL,
    userSelectedConstants.TERMINAL_ID,
    userSelectedConstants.LOCATION,
    userSelectedConstants.TERMINAL_NAME,
    userSelectedConstants.IS_GET_GEOLOCATION,
  ],
  [CONSENT_NAME.PERSONALIZATION_STORAGE]: [],
  [CONSENT_NAME.SECURITY_STORAGE]: [],
};

export const CONSENT_VALUES = {
  GRANTED: 'granted',
  DENIED: 'denied',
  GRANT: 'grant',
  REVOKE: 'revoke',
} as const;
